import type { GatsbyBrowser } from 'gatsby';
import React from 'react';
import Layout from './src/components/Layout';
import type { PageContext } from './src/types';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  return <Layout pageContext={props.pageContext as PageContext}>{element}</Layout>;
};

// Track outbound links automatically
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  if (typeof window !== 'undefined') {
    const eventName = 'Outbound Link';
    document.querySelectorAll('a').forEach((a) => {
      if (a.host !== window.location.host && !a.getAttribute('data-umami-event')) {
        a.setAttribute('data-umami-event', eventName);
        a.setAttribute('data-umami-event-url', a.href);
      }
    });
  }
};
